import { kReferralActivatePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { getAuth } from 'firebase/auth'
import { nanoid } from 'nanoid'
import * as Sentry from '@sentry/browser'
import { kErrorCodeAuthError } from '@/constants/constants-error-codes'

export default async function activateReferral(referralCode: string): Promise<void> {
  const sentry_transaction_id = nanoid()

  try {
    const user = getAuth().currentUser
    const token = await user?.getIdToken(true)
    if (!token) throw Error(kErrorCodeAuthError)

    // Log the referral activation attempt for reference
    console.log(`Attempting to activate referral for user ${user?.uid} with referral code: ${referralCode}`)

    // Construct request
    const apiUrl = kPaxtonAppApiRESTBaseUrl() + kReferralActivatePath
    const requestOptions: RequestInit = {
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Transaction-Id': sentry_transaction_id,
        Authorization: `Bearer ${token}`,
      },
      method: 'POST',
      body: JSON.stringify({ referral_code: referralCode }),
    }

    const response = await fetch(apiUrl, requestOptions)
    const data = await response.json()

    if (!response.ok) {
      const error = new Error(`Fetch error - status: ${response.status}, detail: ${data.detail}`)

      Sentry.withScope((scope) => {
        scope.setTags({ transaction_id: sentry_transaction_id })

        Sentry.captureException(error, {
          extra: {
            requestUrl: apiUrl,
            requestOptions: JSON.stringify(requestOptions),
            response: JSON.stringify(data),
            onLine: navigator.onLine,
            cookieEnabled: navigator.cookieEnabled,
          },
        })
      })

      throw error
    }
  } catch (e) {
    Sentry.withScope((scope) => {
      scope.setTags({ transaction_id: sentry_transaction_id })

      Sentry.captureException(e, {
        extra: { onLine: navigator.onLine, cookieEnabled: navigator.cookieEnabled },
      })
    })
    throw e
  }
}
